import Typography from "@mui/joy/Typography";
import Tooltip from "@mui/joy/Tooltip";
import Stack from "@mui/joy/Stack";
import Divider from "@mui/joy/Divider";
import {FHRequestType} from "stores/fhrequest_store";
import useCurrentIdentity from "hooks/useCurrentIdentity";
import { money } from "utils/misc";

export default function RequestPrice({request}: {request: FHRequestType}) {
    const currentIdentity = useCurrentIdentity();

    if(currentIdentity.role == 'client') return null;

    return (
        <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" />} alignItems="center">
            <Tooltip arrow title="Price for this request. This is not shown to the client.">
                <Typography color="success">{money(request.price)} </Typography>
            </Tooltip>
        </Stack>
    );
}
